import "./ui/style.css";
import Phaser from "phaser";
import { canvasSize, keepCanvasSharp, pixelRatio, watchFrameRate } from "./game/display";
import { watchForUpdates } from "./game/pwa-update";
import { BootScene } from "./game/scenes/boot-scene";
import { GameScene } from "./game/scenes/game-scene";
import { PreloadScene } from "./game/scenes/preload-scene";
import { isTypingTarget } from "./ui/dom";
import { Overlay } from "./ui/overlay";

const container = document.getElementById("game-container");
const uiRoot = document.getElementById("ui-root");
if (!container || !uiRoot) throw new Error("#game-container / #ui-root missing from index.html");

const ratio = pixelRatio();
const initial = canvasSize(container.clientWidth, container.clientHeight, ratio);
const game = new Phaser.Game({
	type: Phaser.AUTO,
	title: "Halloweenstaden",
	parent: container,
	backgroundColor: "#05070f",
	// The canvas has the screen's real pixels; keepCanvasSharp keeps it sized (src/game/display.ts).
	scale: {
		mode: Phaser.Scale.NONE,
		width: initial.width,
		height: initial.height,
		zoom: 1 / ratio,
		fullscreenTarget: "app",
	},
	scene: [BootScene, PreloadScene, GameScene],
});
game.events.once(Phaser.Core.Events.READY, () => {
	keepCanvasSharp(game, container);
	watchFrameRate(game);
});
game.registry.set("overlay", new Overlay(uiRoot));

// Offline play / installable app: the service worker exists only in production builds.
if (import.meta.env.PROD) {
	watchForUpdates();
}

// `?probe`: cross-engine determinism check (tests/e2e/determinism.spec.ts).
if (new URLSearchParams(window.location.search).has("probe")) {
	void import("./sim/determinism-probe").then(({ runDeterminismProbe }) => {
		(window as unknown as { gameProbe: unknown }).gameProbe = runDeterminismProbe;
	});
}

// F toggles fullscreen (a key press counts as the user gesture browsers require).
window.addEventListener("keydown", (ev) => {
	if (ev.code === "KeyF" && !ev.repeat && !isTypingTarget(ev)) {
		if (game.scale.isFullscreen) game.scale.stopFullscreen();
		else game.scale.startFullscreen();
	}
});
